export var TextRendering;
(function (TextRendering) {
    function render_digspot(spot) {
        return c("<span>").addClass("ctr-digspot-inline").text(spot?.toString());
    }
    TextRendering.render_digspot = render_digspot;
    function render_scanregion(name) {
        return c("<span>").addClass("ctr-scanspot-inline").text(name);
    }
    TextRendering.render_scanregion = render_scanregion;
})(TextRendering || (TextRendering = {}));
